import { Column, Entity, PrimaryGeneratedColumn } from 'typeorm';
import { BaseEntity } from './BaseEntity';
import { IRefInstallationCategory } from './interface/IRefInstallationCategory';

@Entity('ref_installation_category')
export class RefInstallationCategory extends BaseEntity implements IRefInstallationCategory{
  apiMapping = {
      id: 'id',
      name: 'name',
  };

  @PrimaryGeneratedColumn()
  id: number;

  @Column()
  name: string;

  @Column({ nullable: true })
  isDeleted: boolean;
}
